export default __webpack_public_path__ + "static/media/56.a7c7d7cd.png";